import React, {Fragment} from 'react';
import createForm from "./Form";
import {CurrencyFormatter, DateFormatter, PartnerSelect} from "../../../utils/formatters";
import ComponentConfig from "../../form/ComponentConfig";
import isEqual from "lodash-es/isEqual";
import TextInput from "../../form/TextInput";
import Select from "../../form/Select";
import DateTimeInput from "../../form/DateTimeInput";
import TextArea from "../../form/TextArea";
import PickList from "../../form/operationlist/PickList";
import {ifCompletedInput} from "../../../utils/other";
import {fileUpload, postData} from "../../../utils/request";
import ImportButton from "../../form/ImportButton";
import parse_str from "locutus/php/strings/parse_str";
import classNames from 'classnames';
import RadioGroup from "../../form/RadioGroup";
import {Tooltip} from "react-tippy";
import CheckBox from "../../form/CheckBox";
import Icon from "../../form/Icon";
import DetailsButton from "../../form/DetailsButton";
import Button from "../../form/Button";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import InvoiceList from "../lists/invoiceList";
import {invoiceTypes, providerTypes} from "../invoiceEditor";
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import ComponentField from "../../form/ComponentField";
import ModalEditor from "../ModalEditor";
import TransactionPaymentEditor from "../TransactionPaymentEditor";
import None from "../None";
import FragmentEditor from "../FragmentEditor";

const percentColors = [
    {pct: 0.0, color: {r: 13, g: 219, b: 13}},
    {pct: 1.0, color: {r: 255, g: 0, b: 0}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

class RoundingCorrectionButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            opened: false,
            amount: this.props.transaction.balance
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.transaction.balance, prevProps.transaction.balance)) {
            this.setState({
                amount: this.props.transaction.balance
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        header="Kerekítéses kompenzáció"
                        size="small"
                        state={this.state.opened}
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: "Kompenzálás",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClick: async () => {
                                    try {
                                        this.setState({isLoading: true});
                                        await postData({
                                            action: 'RoundingCorrection.create',
                                            data: {
                                                transaction: this.props.transaction.id,
                                            }
                                        });
                                        this.props.callBack && this.props.callBack();
                                        this.setState({opened: false, isLoading: false});
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }
                            }
                        ]}
                    >
                        <b>Biztos? {CurrencyFormatter(this.state.amount).props.children} kerekítés lesz hozzáadva!</b>
                    </Modal>
                </Portal>
                <Button
                    disabled={this.state.amount == 0}
                    icon={{lib: "fas", name: "receipt"}}
                    size="xs"
                    color="default"
                    tooltip="Kerekítéses kompenzáció"
                    block={true}
                    onClick={(e) => {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                        this.setState({opened: true});
                        return false;
                    }}
                />
            </Fragment>
        );
    }
}

class FieldEditor extends React.Component {

    render() {
        return (
            <Fragment>
                <Button
                    color="default"
                    size="xs"
                    onClick={() => this.editor && this.editor.focus()}
                    tooltip="Kiegyenlítések"
                    icon={{name: "money-check-alt", lib: "fas"}}
                />
                <ModalEditor ref={(editor) => this.editor = editor} {...this.props} />
            </Fragment>
        );
    }
}

class TransactionPaymentModalList extends React.Component {

    render() {
        return (
            <Fragment>
                <TransactionPaymentEditor
                    loader={null}
                    presets={{transaction: this.props.transactionId}}
                    editor={None}
                    list={FieldEditor}
                    listFilter={[{
                        field: "transaction",
                        value: this.props.transactionId
                    }]}
                />
            </Fragment>
        );
    }
}

class MoneyTransferForm extends React.Component {

    state = {
        idFilter: [],
        filtered: false,
        parameters: {},
        maxAmount: 0
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.values[this.props.componentConfig.idfield], prevProps.values[prevProps.componentConfig.idfield])) {
            this.setState({
                maxAmount: 0
            });
        }
    }

    convert = (row) => {
        row.qty = row.amount || 0;
        return row;
    }

    onTransferItems = async (event, items) => {
        let actionparams = {
            parentcomponent: this.props.componentConfig.componentname,
            listfield: "TransactionPayments",
            parentid: this.props.values[this.props.componentConfig.idfield]
        };

        switch (event.direction) {
            case 'toTarget': {
                items = items.map((_item) => {
                    const item = {};
                    item.transaction = _item.id;
                    item.payment_component = this.props.componentConfig.componentname;
                    item.payment_component_id = this.props.values[this.props.componentConfig.idfield];
                    if (this.state.maxAmount == 0) {
                        item.amount = 0;
                    } else if (/*Math.sign(_item.relativeamount) + "" === "" + this.props.values.direction && */Math.sign(_item.balance) + "" === "" + this.props.values.direction) {
                        item.amount = Math.min(Math.abs(_item.balance), Math.abs(this.props.values.amount), Math.abs(this.state.maxAmount));
                    } else {
                        item.amount = 0;
                    }
                    return item;
                }).filter((i) => !!i);
                if (!items.length) return;
                actionparams = {
                    ...actionparams,
                    action: "componentlist.addItemsToList",
                    items: items.map((item) => ({data: item}))
                };
                const ret = await postData(actionparams);
                this.setState({maxAmount: 0});
                this.picklist.source.refresh();
                this.picklist.target.refresh();
                return ret;
            }
            case 'toSource': {
                actionparams = {
                    ...actionparams,
                    action: "componentlist.removeItemsFromList",
                    items: items
                };
                const ret = await postData(actionparams);
                this.setState({maxAmount: 0});
                this.picklist.source.refresh();
                this.picklist.target.refresh();
                return ret;
            }
        }
    }

    onTargetItemUpdate = async (item) => {
        if (this.props.values.direction + "" === "" + Math.sign(parseFloat(item.transaction.balance) + parseFloat(item.total)) /*&& Math.sign(parseFloat(item.transaction.balance) + parseFloat(item.total)) + "" === "" + this.props.values.direction*/) {
            const updateItem = {};
            updateItem.id = item.id;
            const maxAmount = (this.props.values.amount - this.state.maxAmount - item.amount);
            updateItem.amount = Math.min(this.props.values.amount - maxAmount, Math.abs(item.total));
            if (updateItem.amount + "" === "" + item.amount) {
                return false;
            }
            /*updateItem.amount = Math.min(Math.abs(item.transaction.balance) + Math.abs(item.amount), parseFloat(this.state.maxAmount) + parseFloat(item.amount), this.props.values.amount, Math.abs(item.total));
            updateItem.total = Math.sign(this.props.values.direction) * updateItem.amount;
            if (updateItem.amount + "" === "" + item.amount) {
                return updateItem;
            }*/
            let actionparams = {
                parentcomponent: this.props.componentConfig.componentname,
                listfield: "TransactionPayments",
                parentid: this.props.values[this.props.componentConfig.idfield],
                action: "componentlist.updateItems",
                items: [updateItem]
            };
            await postData(actionparams);
            this.setState({maxAmount: 0});
            return true;
        } else {
            return false;
        }
    }

    importFile = async (field, value) => {
        await this.props.processAction(async () => {
            try {
                const response = await fileUpload({action: this.props.componentConfig.componentname + ".import", file: value, data: this.props.values});
                if (response.success) {
                    this.picklist && this.picklist.refreshBackground();
                    this.props.reloadForm && this.props.reloadForm();
                }
                if (response.redirect) {
                    let params = {};
                    parse_str(response.redirect.substr(1), params);
                    this.props.setContent(params.option, params);
                }
            } catch (e) {
                console.error(e);
            }
        });
    }

    render() {
        const sortable = true;
        const filterable = true;
        const invoiceFilter = [
            {filters: [{field: "invoice.from", value: this.props.till.pos.partner.partner_id},{field: "invoice.to", value: this.props.till.pos.partner.partner_id}], operator: "OR"},
            {field: "MoneyTransfer_id", value: this.props.values[this.props.componentConfig.idfield], operator: "!<=>"},
            {field: "balance", value: 0, operator: "!="},
            {field: "invoice.type", value: [666], operator: "not in"},
            {filters: [{field: "invoice.billnum", operator: "not isnull"}, {field: "invoice.billnum", value: "", operator: "!="}], operator: "OR"}
        ];
        if (this.props.values.partner && this.props.values.partner.partner_id) {
            invoiceFilter.push({field: "invoice.partner", value: this.props.values.partner.partner_id});
            /*invoiceFilter.push({
                filters: {
                    operator: "OR",
                    filters: [
                        {
                            field: "invoice.from", value: this.props.values.partner.partner_id
                        },
                        {
                            field: "invoice.to", value: this.props.values.partner.partner_id
                        }
                    ]
                }
            });*/
        }
        if (this.state.idFilter.length) {
            invoiceFilter.push({field: "invoice", value: this.state.idFilter, operator: "not in"});
        }
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-10">
                        <Select
                            label="Számla"
                            name="moneyrepository"
                            component="MoneyRepository"
                            filter={[{field: "component_type", value: this.props.moneyrepositoryType}]}
                            objectValue={true}
                            labelKey="name"
                            valueKey="repository_id"
                            storeType="local"
                            {...this.props.getFieldProps("moneyrepository")}
                            value={this.props.values.moneyrepository}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-2">
                        <RadioGroup
                            name="direction"
                            labelKey="label"
                            valueKey="value"
                            objectValue={false}
                            options={[{value: 1, label: "Bejövő"},{value: -1, label: "Kimenő"}]}
                            value={this.props.values.direction}
                            label={<Fragment>&nbsp;</Fragment>}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("direction")}
                        />
                    </div>
                    <div className="col-md-5">
                        <div className="row">
                            <div className="col-md-8">
                                <Select
                                    label="Partner"
                                    name="partner"
                                    component="partner"
                                    objectValue={true}
                                    isCreatAble={true}
                                    isClearable={true}
                                    optionsTemplate={PartnerSelect}
                                    labelKey="name"
                                    valueKey="partner_id"
                                    storeType="remote"
                                    {...this.props.getFieldProps("partner")}
                                    value={this.props.values.partner || {partner_id: null, name: this.props.values.partner_name}}
                                    saveChanges={(field, value) => {
                                        if (!(value || {}).partner_id) {
                                            this.props.setFieldValue(field, null);
                                            this.props.setFieldValue("partner_name", (value || {}).name);
                                        } else {
                                            this.props.setFieldValue(field, value);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-md-4">
                                <ImportButton
                                    {...this.props.getFieldProps("import")}
                                    data={this.props.values}
                                    disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.getFieldProps("import").disabled || !this.props.values.partner}
                                    componentConfig={this.props.componentConfig}
                                    label={<Fragment>&nbsp;</Fragment>}
                                    name="file"
                                    saveChanges={this.importFile}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 currency">
                        <TextInput
                            type="number"
                            name="amount"
                            label="Összeg"
                            formatter={CurrencyFormatter}
                            value={this.props.values.amount}
                            {...this.props.getFieldProps("amount")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-3">
                        <DateTimeInput
                            name="transferdate"
                            label="Fizetés dátuma"
                            {...this.props.getFieldProps("transferdate")}
                            value={this.props.values.transferdate}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="comment.text"
                            value={(this.props.values.comment || {}).text}
                            label="Megjegyzés"
                            {...this.props.getFieldProps("comment")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <Fragment>
                    <div className="form-group">
                        <label className="control-label">Számlák</label>
                        <PickList
                            {...this.props.getFieldProps("transfers")}
                            loading={this.props.isLoading}
                            ref={(el) => this.picklist = el}
                            className={"p-small-table"}
                            data={this.props.values}
                            saveChanges={this.setFieldValue}
                            source={{
                                component: "businesstransaction",
                                reqparams: {exact: true},
                                pageSize: 5,
                                view: ["invoice.from.partner_id","invoice.acting.partner_id","invoice.type","invoice.invoice_id","balance","total","paid","amount","client_component","client_component_id"],
                                filter: invoiceFilter,
                                parameters: this.state.parameters,
                                rowClassName: (rowData) => {
                                    return {"danger color": parseFloat(rowData.amount || "0") + "" !== "" + parseFloat(rowData.paid || "0"), "success color": parseFloat(rowData.amount || "0") + "" === "" + parseFloat(rowData.paid || "0")};
                                },
                                columns: {
                                    "client_component": {
                                        header: ' ',
                                        width: 'cell-button',
                                        renderer: (value, rowData) => {
                                            return <div className="nowrap">
                                                <DetailsButton
                                                    loader={null}
                                                    icon={true}
                                                    block={false}
                                                    component_type={rowData.client_component}
                                                    component_id={rowData.client_component_id}
                                                />
                                                <DetailsButton
                                                    loader={null}
                                                    icon={{name: "file-invoice", lib: "fas"}}
                                                    block={false}
                                                    component_type="invoice"
                                                    component_id={rowData.invoice.invoice_id}
                                                />
                                                <TransactionPaymentModalList transactionId={rowData.id} />
                                            </div>;
                                        }
                                    },
                                    "invoice.billnum": {
                                        header: 'Sorszám',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        onFilter: (field, value, operator, validate, column, matchmode) => {
                                            this.setState({parameters: {...this.state.parameters, billnum: value}});
                                        },
                                        renderer: (value, rowData) => {
                                            const roundAmount = Math.round(rowData.amount);
                                            const roundBalance = Math.round(rowData.balance);
                                            const percent = (Math.abs(roundBalance) / roundAmount).toFixed(2);
                                            return <Fragment>{parseFloat(rowData.balance) !== 0 ? <Icon style={{color: getColorForPercentage(percent)}} className="pull-right" lib="fas" name={parseInt(rowData.balance) < 0 ? "money-bill-wave" : "money-bill"} tooltip={<Fragment>Teljes összeg: {CurrencyFormatter(rowData.amount).props.children} <br/>Kiegyenlítetetlen összeg: {CurrencyFormatter(rowData.balance).props.children}</Fragment>}/> : null} {value}</Fragment>;
                                        }
                                    },
                                    "invoice.deadline": {
                                        header: 'Határidő',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "invoice.partner.name": {
                                        header: 'Partner',
                                        width: 7,
                                        sortable,
                                        filterable
                                    },
                                    "invoice.totalprice": {
                                        header: 'Számla végösszeg',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency"
                                    },
                                    "relativeamount": {
                                        header: 'Tranzakció összege',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency"
                                    },
                                    "balance": {
                                        header: "Kiegyenlítetlen összeg",
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency"
                                    },
                                    "client_component_id": {
                                        header: ' ',
                                        width: 'cell-button',
                                        renderer: (value, rowData) => {
                                            return <Fragment>
                                                <RoundingCorrectionButton
                                                    callBack={() => {
                                                        this.picklist.source.refresh();
                                                        this.picklist.target.refresh();
                                                        this.props.reloadAmount && this.props.reloadAmount();
                                                    }}
                                                    transaction={rowData}
                                                    value={value}
                                                    rowData={rowData}
                                                />
                                            </Fragment>;
                                        }
                                    },
                                }
                            }}
                            onTransferItems={this.onTransferItems}
                            onTargetItemUpdate={this.onTargetItemUpdate}
                            target={{
                                onLoadCompleted: (response) => {
                                    let maxAmount = ((response.aggregations || [])[0] || {}).amount;
                                    if (maxAmount === undefined) {
                                        maxAmount = this.props.values.amount;
                                    } else {
                                        maxAmount = this.props.values.amount - maxAmount;
                                    }
                                    if ((response.aggregations || []).length) {
                                        response.aggregations.push({
                                            "transaction.balance": response.aggregations[0].totalbalance,
                                        });
                                        response.aggregations.push({
                                            "total": response.aggregations[0].compensated,
                                        });
                                        response.aggregations.push({
                                            "transaction.relativeamount": response.aggregations[0]["transaction.relativeamount"],
                                            "transaction.balance": response.aggregations[0].overall,
                                        });
                                        response.aggregations[0]["transaction.relativeamount"] = null;
                                    }
                                    this.setState({idFilter: (response.rows || []).map((data) => (data.invoice || {}).invoice_id).filter((id) => !!id), maxAmount});
                                },
                                exports: [{as: "excel", label: "Excel", icon: "far fa-file-excel"}],
                                component: this.props.componentConfig.componentname,
                                listfield: "TransactionPayments",
                                pageSize: 15,
                                view: ["amount","total","invoice.from.partner_id","invoice.acting.partner_id","invoice.invoice_id","transaction.balance","transaction.id","transaction.relativeamount","transaction.total","transaction.paid","transaction.amount","transaction.client_component","transaction.client_component_id"],
                                rowClassName: (rowData) => {
                                    return {"danger color": parseFloat(rowData.transaction.amount || "0") + "" !== "" + parseFloat(rowData.transaction.paid || "0"), "success color": parseFloat(rowData.transaction.amount || "0") + "" === "" + parseFloat(rowData.transaction.paid || "0")};
                                },
                                paginatorRight: () => <Tooltip title={!this.state.filtered ? "Csak az eltérések mutatása" : "Mindent mutat"}><CheckBox
                                onIcon={{lib: "fa", name: "box"}}
                                offIcon={{lib: "fa", name: "box-open"}}
                                value={this.state.filtered}
                                label={false}
                                saveChanges={(field, value) => {
                                    this.setState({filtered: !!value});
                                }}
                                /></Tooltip>,
                                aggregations: {
                                    fields: {
                                        "total": {
                                            field: "total", type: "SUM"
                                        },
                                        "amount": {
                                            field: "amount", type: "SUM"
                                        },
                                        "transaction.balance": {
                                            field: "transaction.balance", type: "SUM"
                                        },
                                        "transaction.relativeamount": {
                                            field: "transaction.relativeamount", type: "SUM"
                                        },
                                        "totalbalance": {
                                            expression: "({{transaction.balance}} + {{total}})"
                                        },
                                        "compensated": {
                                            expression: "({{transaction.relativeamount}} - {{totalbalance}})"
                                        },
                                        "overall": {
                                            expression: "{{compensated}} + {{totalbalance}}"
                                        }
                                    }
                                },
                                filter: this.state.filtered ? [{field: 'invoice', operator: 'not isnull'},{field: "transaction.balance", value: 0, operator: "!="}] : [{field: 'invoice', operator: 'not isnull'}],
                                columns: {
                                    "client_component": {
                                        header: ' ',
                                        width: 'cell-button',
                                        aggregationProps: (row, {rowIndex}) => ({
                                            colSpan: rowIndex < 3 ? 6 : 5,
                                            rowSpan: rowIndex == 0 ? 3 : 1
                                        }),
                                        renderer: (value, rowData) => {
                                            return <div className="nowrap">
                                                <DetailsButton
                                                    loader={null}
                                                    icon={true}
                                                    block={false}
                                                    component_type={rowData.transaction.client_component}
                                                    component_id={rowData.transaction.client_component_id}
                                                />
                                                <DetailsButton
                                                    loader={null}
                                                    icon={{name: "file-invoice", lib: "fas"}}
                                                    block={false}
                                                    component_type="invoice"
                                                    component_id={rowData.invoice.invoice_id}
                                                />
                                                <TransactionPaymentModalList transactionId={rowData.transaction.id} />
                                            </div>;
                                        }
                                    },
                                    "invoice.billnum": {
                                        header: 'Sorszám',
                                        width: 2,
                                        sortable,
                                        filterable,
                                        renderer: (value, rowData) => {
                                            const roundAmount = Math.round(rowData.transaction.amount);
                                            const roundBalance = Math.round(rowData.transaction.balance);
                                            const percent = (Math.abs(roundBalance) / roundAmount).toFixed(2);
                                            return <Fragment>{parseFloat(rowData.transaction.balance) !== 0 ? <Icon style={{color: getColorForPercentage(percent)}} className="pull-right" lib="fas" name={parseInt(rowData.transaction.balance) < 0 ? "money-bill-wave" : "money-bill"} tooltip={<Fragment>Teljes összeg: {CurrencyFormatter(rowData.transaction.amount).props.children} <br/>Kiegyenlítetetlen összeg: {CurrencyFormatter(rowData.transaction.balance).props.children}</Fragment>}/> : null} {value}</Fragment>;
                                        }
                                    },
                                    "invoice.deadline": {
                                        header: 'Határidő',
                                        width: 1,
                                        sortable,
                                        filterable
                                    },
                                    "invoice.partner.name": {
                                        header: 'Partner',
                                        width: 6,
                                        sortable,
                                        filterable
                                    },
                                    "invoice.totalprice": {
                                        header: 'Számla végösszeg',
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency"
                                    },
                                    "transaction.relativeamount": {
                                        header: "Tranzakció összege",
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency"
                                    },
                                    "transaction.balance": {
                                        header: "Kiegyenlítetlen összeg",
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency",
                                        aggregation: (value, row, rowIndex) => {
                                            if (rowIndex === 0 || rowIndex % 2 > 0) {
                                                return CurrencyFormatter(value);
                                            } else {
                                                return "Egyéb kiegyenlítések";
                                            }
                                        },
                                        aggregationProps: (row, {rowIndex}) => ({
                                            colSpan: rowIndex === 0 || rowIndex % 2 === 0 ? 0 : 2
                                        })
                                    },
                                    "total": {
                                        header: "Összeg",
                                        width: 1,
                                        sortable,
                                        filterable,
                                        renderer: CurrencyFormatter,
                                        className: "nowrap currency",
                                        columnClassName: (field, value, rowData, rows, props) => !props.isAggregation ? (Math.sign(parseFloat(rowData.transaction.balance) + parseFloat(rowData.total)) + "" === "" + this.props.values.direction ? "" : "disabled-field") : null,
                                        editor:
                                            (parent) =>
                                                (props, value) =>
                                                    Math.sign(parseFloat(props.rowData.transaction.balance) + parseFloat(props.rowData.total)) + "" === "" + this.props.values.direction ? <TextInput type="decimal" negative={true} name="total" label={false} focus="focus" value={props.rowData.total}
                                                               onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                                               onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}
                                                    /> : null
                                    },
                                    "client_component_id": {
                                        header: ' ',
                                        width: 'cell-button',
                                        aggregationProps: (row, {rowIndex}) => ({
                                            rowSpan: rowIndex == 0 ? 4 : 1
                                        }),
                                        renderer: (value, rowData) => {
                                            if (Math.sign(rowData.transaction.relativeamount) + "" === "" + this.props.values.direction) {
                                                return <Fragment>
                                                    <RoundingCorrectionButton
                                                        callBack={() => {
                                                            this.picklist.source.refresh();
                                                            this.picklist.target.refresh();
                                                            this.props.reloadAmount && this.props.reloadAmount();
                                                        }}
                                                        transaction={rowData.transaction}
                                                        value={value}
                                                        rowData={rowData}
                                                    />
                                                </Fragment>;
                                            } else {
                                                return null;
                                            }
                                        }
                                    },
                                },
                                convert: this.convert
                            }}
                        />
                    </div>
                </Fragment>}
                {
                    !!(this.props.values.compensations || []).length &&
                    this.props.values.compensations.map((compensation, idx) => <div key={idx} className="row form-row">
                        <div className="col-md-10">
                            <div className="form-group">
                                <TextInput
                                    value={compensation.transferdate}
                                    label="Kompenzáció dátuma"
                                    disabled={true}
                                    formatter={DateFormatter}
                                />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <DetailsButton
                                    component_type="Compensation"
                                    component_id={compensation.id}
                                />
                            </div>
                        </div>
                    </div>)
                }
            </form>
        );
    }
}

export default createForm(MoneyTransferForm);
